export default "__VITE_ASSET__Cf9KznyT__"